import { useTimezone } from '@app/core/hooks/useTimezone';
import { Station } from '@app/core/types/stations';
import { getAuditListingDefaultDateRange } from '@app/modules/audit/modules/station-audit/helpers/default-listing-date-range';
import { AuditLiveMention } from '@app/modules/audit/modules/station-audit/types';
import {
  crudListToPaginated,
  datetimeRangeCrudFilters,
  toCrudSort,
} from '@app/modules/audit/utils/audit-matches-crud';
import { auditMentionsAuditMentionsMatchesList } from '@mi-front/api-v2';
import { ListingView } from '../../../../../../../../core/reports/components/ListingView';
import { MentionsMatchesForm } from './MentionsMatchesForm';
import { MentionsMatchesList } from './MentionsMatchesList';
import { MentionsMatchesListing } from './types';

type Props = {
  station: Station;
};

/**
 * Station live-mention matches listing; fetches via api-v2 CRUD mentions list.
 */
export function MentionsMatchesView(p: Props) {
  const tz = useTimezone();

  return (
    <ListingView<MentionsMatchesListing>
      defaultValues={{
        ...getAuditListingDefaultDateRange(tz),
        name: '',
      }}
      queryParamsTransform={{
        name: {
          parse: (input) => input,
          serialize: (input) => input.replace(/\s/g, ''),
        },
      }}
      reportFn={async (values) => {
        const names = values.name
          ?.split(',')
          .map((value) => value.trim())
          .filter((value) => !!value);

        const res = await auditMentionsAuditMentionsMatchesList({
          station: p.station.id,
          filter: [
            ...datetimeRangeCrudFilters(values.from, values.to),
            ...(names?.map((name) => `name||$eq||${name}`) ?? []),
          ],
          page: (values.pageIndex ?? 0) + 1,
          limit: values.pageSize,
          sort: toCrudSort(values.sort) ?? ['datetime,DESC'],
          join: ['confirmedSchedule'],
        });

        return crudListToPaginated({
          ...res,
          data: res.data as AuditLiveMention[],
        });
      }}
      Form={MentionsMatchesForm}
      Result={MentionsMatchesList}
    />
  );
}
